export default __webpack_public_path__ + "static/media/pepsi.bd6590c5.png";